import _filter from "lodash/filter"
import _map from "lodash/map"
import _split from "lodash/split"
import _isNil from "lodash/isNil"
import moment from "moment"

import convertQuotaBytesTo from "services/utils/convertQuotaBytesTo"

moment.locale("pt-br")

export const formatDataTraffic = (data) => {
  const dataTraffic = _filter(
    data,
    (item) =>
      !_isNil(item.profile) &&
      item.profile !== "GIGA PRE 30 DIAS - LOCAL" &&
      item.displayScreen !== "0" &&
      item.displayScreen !== 0
  )

  return _map(dataTraffic, (item) => {
    const balance = _split(item.balanceId, "_")
    const dataTrafficName =
      balance[4] === "ILIMITADO"
        ? `${balance[2]} ${balance[4]} NOITE`
        : balance[2]

    return {
      ...item,
      dataTrafficName,
      balanceAvailable: convertQuotaBytesTo(item.balanceAvailable),
      creditLimit: convertQuotaBytesTo(item.creditLimit),
      expiryDate: moment(item.expiryDate).format("DD/MM/YYYY"),
      effectiveDate: moment(item.effectiveDate).format("DD/MM/YYYY")
    }
  })
}



// WEBPACK FOOTER //
// ./src/scenes/DataQuota/utils/dataTrafficHelpers.js